import { numberWithSpaces } from './numberWithSpaces'

export const formatNumber = (x: number) => {
  return x ? numberWithSpaces(x.toFixed(2)) : '0.00'
}
